module.exports = __webpack_public_path__ + "img/img12.00a7f97b.svg";